export const insuranceQuestions = {
  booleanOptions: [
    {
      text: "בחר",
      value: ""
    },
    {
      text: "כן",
      value: true
    },
    {
      text: "לא",
      value: false
    }
  ],
  insuranceCompanyOptions: [
    {
      text: "בחר",
      value: ""
    },
    {
      text: "מנורה",
      value: "מנורה"
    },
    {
      text: "פניקס",
      value: "פניקס"
    },
    {
      text: "איילון חברה לביטוח",
      value: "איילון חברה לביטוח"
    },
    {
      text: "כלל",
      value: "כלל"
    },
    {
      text: "הראל",
      value: "הראל"
    },
    {
      text: "מגדל",
      value: "מגדל"
    },
    {
      text: "ביטוח ישיר",
      value: "ביטוח ישיר"
    },
    {
      text: "דיקלה",
      value: "דיקלה"
    },
    {
      text: "אליהו",
      value: "אליהו"
    },
    {
      text: "הכשרה",
      value: "הכשרה"
    }
  ],
  careServicesOptions: [
    { text: "בחר", value: "" },
    { text: "כללית", value: "כללית" },
    { text: "מאוחדת", value: "מאוחדת" },
    { text: "מכבי", value: "מכבי" },
    { text: "לאומית", value: "לאומית" },
    { text: "ללא קופה", value: "ללא קופה" }
  ],
  payOptions: [
    { text: "חברת ביטוח", value: "חברת ביטוח" },
    { text: "מחלקה הבינלאומית", value: "מחלקה הבינלאומית" },
    { text: "מדיקל", value: "מדיקל" },
    { text: "פרטי", value: "פרטי" }
  ],
  clalitOptions: [
    { text: "בחר", value: "" },
    { text: "כללית מושלם", value: "כללית מושלם" },
    { text: "חברת ביטוח", value: "חברת ביטוח" },
    { text: "כללית קיצור תורים", value: "כללית קיצור תורים" },
    { text: "פרטי", value: "פרטי" },
    { text: "כללית מחוז דן פתח תקווה", value: "כללית מחוז דן פתח תקווה" },
    { text: "כללית מחוז חיפה גנז", value: "כללית מחוז חיפה גנז" },
    { text: "כללית מחוז ירושלים", value: "כללית מחוז ירושלים" },
    { text: "כללית מחוז מרכז", value: "כללית מחוז מרכז" },
    { text: "כללית מחוז צפון", value: "כללית מחוז צפון" },
    { text: "כללית מחוז תל אביב", value: "כללית מחוז תל אביב" },
    { text: "כללית שרון שומרון", value: "כללית שרון שומרון" },
    { text: "בלינסון", value: "בלינסון" },
    { text: "מחלקה הבינלאומית", value: "מחלקה הבינלאומית" },
    { text: "מדיקל", value: "מדיקל" },
    { text: "מרכז רפואי מאיר", value: "מרכז רפואי מאיר" },
    { text: "מרכז רפואי העמק", value: "מרכז רפואי העמק" }
  ],
  meohedetOptions: [
    { text: "בחר", value: "" },
    { text: "מאוחדת שבן", value: "מאוחדת שבן" },
    { text: "מאוחדת סל", value: "מאוחדת סל" }
  ],
  macabiOptions: [
    { text: "בחר", value: "" },
    { text: "מכבי שבן", value: "מכבי שבן" },
    { text: "מכבי סל", value: "מכבי" }
  ],
  leumitOptions: [
    { text: "בחר", value: "" },
    { text: "לאומית שבן", value: "לאומית שבן" },
    { text: "לאומית סל", value: "לאומית" }
  ]
  // otherOptions: [
  //   { text: "אבחון מהיר", value: "אבחון מהיר" },
  //   { text: "בלינסון", value: "בלינסון" },
  //   { text: "כללית מחוז דן פתח תקווה", value: "כללית מחוז דן פתח תקווה" },
  //   { text: "כללית מחוז חיפה גנז", value: "כללית מחוז חיפה גנז" },
  //   { text: "כללית מחוז ירושלים", value: "כללית מחוז ירושלים" },
  //   { text: "כללית מחוז מרכז", value: "כללית מחוז מרכז" },
  //   { text: "כללית מחוז צפון", value: "כללית מחוז צפון" },
  //   { text: "כללית מחוז תל אביב", value: "כללית מחוז תל אביב" },
  //   { text: "כללית קיצור תורים", value: "כללית קיצור תורים" },
  //   { text: "כללית שרון שומרון", value: "כללית שרון שומרון" },
  //   { text: "מאוחדת סל", value: "מאוחדת סל" },
  //   { text: "מחלקה הבינלאומית", value: "מחלקה הבינלאומית" },
  //   { text: "מרכז רפואי העמק", value: "מרכז רפואי העמק" },
  //   { text: "מרכז רפואי מאיר", value: "מרכז רפואי מאיר" }
  // ]
};

export const getFullCareServices = type => {
  if (type === "כללית") return "כללית מושלם";
  if (type === "מאוחדת") return "מאוחדת שבן";
  if (type === "לאומית") return "לאומית שבן";
  return type;
};

export const getShortCareServices = type => {
  if (type === "כללית מושלם") return "כללית";
  if (type === "מאוחדת שבן") return "מאוחדת";
  if (type === "לאומית שבן") return "לאומית";
  return type;
};
